<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  costBreakdown: { type: Object, default: () => ({}) },
});

const { t } = useI18n();

const totalBillable = computed(() => props.costBreakdown?.total_billable || 0);
const byCategory = computed(() => props.costBreakdown?.by_category || {});

const categories = computed(() =>
  Object.entries(byCategory.value).map(([category, count]) => ({
    label: category || 'Unknown',
    count,
  }))
);
</script>

<template>
  <div class="flex flex-col gap-3 p-4 rounded-lg bg-n-alpha-2">
    <div class="flex items-center gap-2">
      <span class="i-lucide-credit-card size-4 text-n-slate-10" />
      <span class="text-xs font-medium text-n-slate-11 uppercase tracking-wide">
        {{ t('CAMPAIGN.WHATSAPP.ANALYTICS.COST.TITLE') }}
      </span>
    </div>
    <div class="flex items-baseline gap-1">
      <span class="text-3xl font-semibold text-n-slate-12">
        {{ totalBillable }}
      </span>
      <span class="text-sm text-n-slate-10">
        {{ t('CAMPAIGN.WHATSAPP.ANALYTICS.COST.BILLABLE') }}
      </span>
    </div>
    <div
      v-if="categories.length > 0"
      class="flex flex-col gap-1 pt-2 border-t border-n-weak"
    >
      <div
        v-for="cat in categories"
        :key="cat.label"
        class="flex items-center justify-between text-xs"
      >
        <span class="text-n-slate-11 capitalize">{{ cat.label }}</span>
        <span class="font-medium text-n-slate-12">{{ cat.count }}</span>
      </div>
    </div>
  </div>
</template>
